/* eslint-disable @typescript-eslint/no-explicit-any */
import { expectContent } from "@/content/utils/expectContent";

import {
    assetFragment,
    collectionFragment,
    relatedTemplateFragment,
    templateFragment
} from "../fragments";
import {
    ITemplatePageLoader,
    parseCategories,
    parseCollection,
    parseTemplate
} from "../get-content-data";

const getParseData = (data: any, locale?: string) => {
    const templates = [];
    const collections = [];
    const categories = parseCategories(data.contentFacet.edges, locale);

    for (const { node } of data.templates.edges) {
        templates.push(parseTemplate(node));
    }

    for (const { node } of data.templateCollections.edges) {
        collections.push(parseCollection(node));
    }

    expectContent(templates[0], "Template not found");

    return {
        templates,
        collections,
        categories
    };
};

export const ConfluenceTemplateDetailsPageLoader: ITemplatePageLoader = {
    getQueryData: (urlSlug: string, locale: string) => {
        return {
            query: `#graphql
            query getTemplateAndRelatedCollections($search: ContentPlatformSearchAPIv2Query!) {
                templates(search: {queries: {first: 1, withLocales: ["${locale}"], where: {searchText: {
                    exactlyMatching: { fieldNamed: "urlSlug", havingValues: ["${urlSlug}"] }}}}}) {
                    edges {
                        node {
                            ...templateFragment
                        }
                    }
                }
                templateCollections(search: $search) {
                    edges {
                        node {
                            ...collectionFragment
                        }
                    }
                }
                contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: ["${locale}"]) {
                    edges {
                      node {
                        context
                      }
                    }
                  }
            }
            ${templateFragment}
            ${collectionFragment}
            ${assetFragment}
            ${relatedTemplateFragment}
            `,
            variables: {
                search: {
                    queries: {
                        first: 50,
                        withLocales: [locale],
                        where: {
                            searchText: {
                                exactlyMatching: {
                                    fieldNamed:
                                        "howToUseThisCollection.collectionSteps.relatedTemplate.urlSlug",
                                    havingValues: [urlSlug]
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    parseData: getParseData
};

export const ConfluenceTemplateDetailsPageWithMlTemplateIdsLoader: ITemplatePageLoader =
    {
        getQueryData: (templateId: string, locale: string) => {
            return {
                query: `#graphql
            query getTemplateAndRelatedCollections($search: ContentPlatformSearchAPIv2Query!) {
                templates(search: {queries: {first: 1, withLocales: ["${locale}"], where: {searchText: {
                    exactlyMatching: { fieldNamed: "templateId", havingValues: ["${templateId}"] }}}}}) {
                    edges {
                        node {
                            ...templateFragment
                        }
                    }
                }
                templateCollections(search: $search) {
                    edges {
                        node {
                            ...collectionFragment
                        }
                    }
                }
                contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: ["${locale}"]) {
                    edges {
                      node {
                        context
                      }
                    }
                  }
            }
            ${templateFragment}
            ${collectionFragment}
            ${assetFragment}
            ${relatedTemplateFragment}
            `,
                variables: {
                    search: {
                        queries: {
                            first: 50,
                            withLocales: [locale],
                            where: {
                                searchText: {
                                    exactlyMatching: {
                                        fieldNamed:
                                            "howToUseThisCollection.collectionSteps.relatedTemplate.templateId",
                                        havingValues: [templateId]
                                    }
                                }
                            }
                        }
                    }
                }
            };
        },
        parseData: getParseData
    };
